import { Injectable } from "@angular/core";
import { AvisInitialService } from "../avis-initial/avis-initial.service";
import { DescriptionService } from "../description/description.service";
import { ProcedureService } from "../procedure/procedure.service";


@Injectable(
    {
        providedIn: 'root'
    })
export class FormmapaServices {

    constructor(public avisInitialService: AvisInitialService,
        public descriptionService: DescriptionService,
        public procedureService: ProcedureService) {
    }
}
